import script from "./ResizeHandle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResizeHandle.vue?vue&type=script&setup=true&lang=ts"

import "./ResizeHandle.vue?vue&type=style&index=0&id=22f83a28&lang=css"
import "./ResizeHandle.vue?vue&type=style&index=1&id=22f83a28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f83a28"]])

export default __exports__